import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { ProctoringExamType } from '../Actions'
import {
  GET_USER_MOVEMENT_IMAGES_ACTION,
  GET_USER_MOVEMENT_IMAGES_ZIP_ACTION,
} from '../constants/action-types'

const initialState = {
  isLoading: false,
  isLoadingZip: false,
  errorMessage: '',
  userMovementData: {},
  userMovementDataZip: {},
}

const reducer = persistReducer(
  { storage, key: 'proctoring_exam', whitelist: [] },
  (state: ProctoringExamType = initialState, action: ActionTypes) => {
    switch (action.type) {
      case GET_USER_MOVEMENT_IMAGES_ACTION.USER_MOVEMENT_IMAGES_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case GET_USER_MOVEMENT_IMAGES_ACTION.USER_MOVEMENT_IMAGES_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
          userMovementData: action.payload as any,
        }

      case GET_USER_MOVEMENT_IMAGES_ACTION.USER_MOVEMENT_IMAGES_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case GET_USER_MOVEMENT_IMAGES_ZIP_ACTION.USER_MOVEMENT_IMAGES_ZIP_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoadingZip: true,
        }

      case GET_USER_MOVEMENT_IMAGES_ZIP_ACTION.USER_MOVEMENT_IMAGES_ZIP_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoadingZip: false,
          userMovementDataZip: action.payload as any,
        }

      case GET_USER_MOVEMENT_IMAGES_ZIP_ACTION.USER_MOVEMENT_IMAGES_ZIP_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoadingZip: false,
        }

      default:
        return state
    }
  }
)

export default reducer
